import React from "react";
var __jsx = React.createElement;
import { BottomSheet } from "@componentsShared/BottomSheet";
import { Icon } from "@syarahtech/ui";
import { useTranslation } from "@i18n";
import errorIcon from "../../assets/report-error.svg";
var FleetResultModal = function FleetResultModal(_ref) {
  var open = _ref.open,
    variant = _ref.variant,
    onClose = _ref.onClose,
    onRetry = _ref.onRetry;
  var _useTranslation = useTranslation(["web_fleet"]),
    tShort = _useTranslation.tShort;
  var isSuccess = variant === "success";
  return /*#__PURE__*/React.createElement(BottomSheet, {
    open: open,
    onOpen: function onOpen() {},
    onClose: onClose,
    haveClose: true,
    hideTitleBar: true,
    modalDesign: {
      closeAnimation: false
    },
    maxWidthDesktop: "480px",
    maxHeight: "50%",
    screens: [{
      component: /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col items-center gap-4 px-6 pb-6"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-center w-20 h-20 rounded-2xl ".concat(isSuccess ? "bg-[#EAFBF1]" : "bg-[#FDECEC]")
      }, isSuccess ? /*#__PURE__*/React.createElement(Icon, {
        icon: "material-symbols--check-circle-outline-rounded",
        className: "text-[#1BB55C]",
        width: 12,
        height: 12
      }) : /*#__PURE__*/React.createElement("img", {
        src: errorIcon,
        alt: "error icon",
        loading: "lazy",
        width: 50,
        height: 50,
        className: "w-[50px] h-[50px] flex-shrink-0 object-contain"
      })), /*#__PURE__*/React.createElement("h3", {
        className: "m-0 text-xl md:text-2xl font-extrabold text-[#1B2035] text-center leading-8"
      }, tShort(isSuccess ? "success_title" : "fail_title", {
        ns: "web_fleet"
      })), /*#__PURE__*/React.createElement("p", {
        className: "m-0 text-base md:text-xl text-center leading-relaxed"
      }, tShort(isSuccess ? "success_desc" : "fail_desc", {
        ns: "web_fleet"
      })), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "text-center md:w-1/2 md:mx-auto  w-full mt-2 py-3 bg-primary-new text-white border-none rounded-lg text-base font-semibold cursor-pointer",
        onClick: isSuccess ? onClose : onRetry
      }, tShort(isSuccess ? "success_button" : "fail_button", {
        ns: "web_fleet"
      })))
    }]
  });
};
export default FleetResultModal;